import { useState, useEffect } from 'react';
import { getUserImages } from 'src/apiCalls';
import logger from 'src/logger';

export const useImageCount = (user: any) => {
  const [imageCount, setImageCount] = useState(0);
  const [uploadDisabled, setUploadDisabled] = useState(false);

  useEffect(() => {
    const fetchUserImages = async () => {
      try {
        const images = await getUserImages(user.accessToken, user.uid);
        if(images){
            setImageCount(images.length);
            setUploadDisabled(images.length >= 11);
        }

      } catch (error) {
        logger.error("Failed to fetch user images:", error);
      }
    };

    fetchUserImages();
  }, [user]);

  return {
    imageCount,
    uploadDisabled,
  };
};